import {useTranslation} from "react-i18next";

import i18n from "locales/i18n";
import SolutionBox from "./SolutionBox";

import bg from 'assets/images/home/main03.png';

export default function Solution(){
  const {t} = useTranslation();
  const locale = i18n.language??'ko';
  
  const item = [];
  for(let i = 1; i < 5; i++){
    const title = t(`home.solutions.title-${i}`)
    const unit = t(`home.solutions.unit-${i}`)
    const value = t(`home.solutions.value-${i}`)
    const obj={title, unit, value, count:0}
    item.push(obj);
  }

  return (
    <div className={`bg flex flex-col items-center py-20 lg:py-32 bg-center px-mobile`} 
      style={{backgroundImage:`url(${bg})`}}>
      <div className="mb-14">
        <h1 className="text-3xl tracking-wide text-white lg:text-5xl">{t('home.solutions.main-title')}</h1>
      </div>
      <div className="flex flex-col items-center">
        <p className="mb-2 text-sm text-white lg:text-xl">{t('home.solutions.main-comment-1')}</p>
        <p className="mb-2 -mt-2 text-sm text-white lg:text-xl">{t('home.solutions.main-comment-2')}</p>
      </div>
      <div className="flex flex-col items-center mt-16 lg:mt-24 lg:mb-20 lg:flex-row lg:justify-center">
        <div className="flex justify-center">
          <SolutionBox key={item[0].title} value={item[0].value} unit={item[0].unit} title={item[0].title} isPrefix={locale==='en'? true:false}/>
          <SolutionBox key={item[1].title} value={item[1].value} unit={item[1].unit} title={item[1].title}/>
        </div>
        <div className="flex justify-center">
          <SolutionBox key={item[2].title} value={item[2].value} unit={item[2].unit} title={item[2].title}/>
          <SolutionBox key={item[3].title} value={item[3].value} unit={item[3].unit} title={item[3].title} isNewLine={locale==='en'? true:false}/>
        </div>
      </div>
    </div>
  );
}